/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Loader} from 'react-overlay-loader';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap"
import maleAvatar from '../../assets/images/Male-Avatar.png';
import computerIcon from '../../assets/images/computer-icon-hover.png';
import alertsIcon from '../../assets/images/alerts-icon.png';
import * as actions from '../../store/actions';
import moment from 'moment';
import Error from "../../components/UI/Error";
import PasswordStrengthBar from 'react-password-strength-bar';
import { API_HOST } from '../../config';

const stateOptions = [
    {value: 'AL', label: 'Alabama'},
    {value: 'AK', label: 'Alaska'},
    {value: 'AZ', label: 'Arizona'},
    {value: 'AR', label: 'Arkansas'},
    {value: 'CA', label: 'California'},
    {value: 'CO', label: 'Colorado'},
    {value: 'CT', label: 'Connecticut'},
    {value: 'DE', label: 'Delaware'},
    {value: 'DC', label: 'District Of Columbia'},
    {value: 'FL', label: 'Florida'},
    {value: 'GA', label: 'Georgia'},
    {value: 'HI', label: 'Hawaii'},
    {value: 'ID', label: 'Idaho'},
    {value: 'IL', label: 'Illinois'},
    {value: 'IN', label: 'Indiana'},
    {value: 'IA', label: 'Iowa'},
    {value: 'KS', label: 'Kansas'},
    {value: 'KY', label: 'Kentucky'},
    {value: 'LA', label: 'Louisiana'},
    {value: 'ME', label: 'Maine'},
    {value: 'MD', label: 'Maryland'},
    {value: 'MA', label: 'Massachusetts'},
    {value: 'MI', label: 'Michigan'},
    {value: 'MN', label: 'Minnesota'},
    {value: 'MS', label: 'Mississippi'},
    {value: 'MO', label: 'Missouri'},
    {value: 'MT', label: 'Montana'},
    {value: 'NE', label: 'Nebraska'},
    {value: 'NV', label: 'Nevada'},
    {value: 'NH', label: 'New Hampshire'},
    {value: 'NJ', label: 'New Jersey'},
    {value: 'NM', label: 'New Mexico'},
    {value: 'NY', label: 'New York'},
    {value: 'NC', label: 'North Carolina'},
    {value: 'ND', label: 'North Dakota'},
    {value: 'OH', label: 'Ohio'},
    {value: 'OK', label: 'Oklahoma'},
    {value: 'OR', label: 'Oregon'},
    {value: 'PA', label: 'Pennsylvania'},
    {value: 'RI', label: 'Rhode Island'},
    {value: 'SC', label: 'South Carolina'},
    {value: 'SD', label: 'South Dakota'},
    {value: 'TN', label: 'Tennessee'},
    {value: 'TX', label: 'Texas'},
    {value: 'UT', label: 'Utah'},
    {value: 'VT', label: 'Vermont'},
    {value: 'VA', label: 'Virginia'},
    {value: 'WA', label: 'Washington'},
    {value: 'WV', label: 'West Virginia'},
    {value: 'WI', label: 'Wisconsin'},
    {value: 'WY', label: 'Wyoming'}
];

const User = "user"
const ReadOnlyUser = "readOnlyUser"

const MetadataUrl = "metadataUrl"
const MetadataFile = "metadataFile"
const SpecifyFieldValues = "specifyFieldValues"

class AccountSettings extends Component {

    state = {
        company: '',
        phone: '',
        street: '',
        unit: '',
        city: '',
        state: this.props.settings.address ? this.props.settings.address.state : '',
        zip: '',
        accounts: [],
        orgs: [],
        gcpProjects: [],
        users: this.props.settings.users ? this.props.settings.users : [],
        sessions: this.props.settings.userSessions ? this.props.settings.userSessions : [],
        scopings: this.props.settings.scopings ? this.props.settings.scopings: [],
        addUser: false,
        editUser: false,
        cloudprovider: 'aws',
        addAccount: false,
        addedAccount: null,
        editAccount: false,
        editProject: false,
        accountOrOrg: '',
        showDelete: false,
        editedUser: null,
        editedUserId: null,
        editedAccount: null,
        editedAccountId: null,
        editedOrg: null,
        editedOrgId: null,
        editedProject: null,
        editedProjectId: null,
        deletedUser: null,
        deletedAccount: null,
        deletedOrg: null,
        deletedProject: null,
        showRevoke: false,
        deletedSession: null,
        deleteApiKey: false,
        changePassword: false,
        showOldPassword: false,
        showPassword: false,
        password: '',
        oldPassword: '',
        addScoping: false,
        editScoping: false,
        deletedScoping: null,
        editedScopingId: null,
        editedScoping: null,
        idpMetadataUrl: '',
        idpSsoUrl: '',
        idpIssuer: '',
        idpMetadataXml: '',
        idpMetadataXmlFile: null,
        idpCertificateFile: null,
        idpCertificateData: '',
        certExpiration: null,
        emailAddrAttribute : '',
        ssoEnabled: false,
        defaultUserType: (this.props.settings.ssoConfig && this.props.settings.ssoConfig.defaultReadonly) ? ReadOnlyUser : User,
        spConfigMode: (this.props.settings.ssoConfig && this.props.settings.ssoConfig.idpSsoUrl) ? SpecifyFieldValues: MetadataUrl,
        spKeyAndCertCreated: this.props.settings.ssoConfig ? this.props.settings.ssoConfig.spKeyAndCertCreated : false,
        guid: this.props.settings.spMetadata? this.props.settings.spMetadata.defaultRelayState : "",
        idpConfigMode: MetadataUrl,
        cpError: null,
    };

    isReadOnly = () => {
        if (this.props.permissions === null || this.props.permissions === undefined) {
            return false;
        }
        if (this.props.permissions.policies === null || this.props.permissions.policies === undefined) {
            return false;
        }
        //for now we only care about READONLY for all features
        if (this.props.permissions.policies.length === 0) {
            return false;
        }
        let p = this.props.permissions.policies[0];
        if (p.role === "ReadOnly" && p.feature === "All") {
            return true;
        }

        return false;
    };

    formatPercent = (x) => {
        return x * 100
    };

    toFloatNumber = (x) => {
        return parseFloat(x) / 100
    };

    formatDate = (x) => {
        if (x === null || x === 0 || x === undefined) {
            return ''
        }
        let y;
        if (typeof x === 'string') {
            y = Number.parseInt(x)
        } else {
            y = x;
        }
        let m = moment.unix(y).utc();
        return m.format("YYYY-MM-DD HH:mm z")
    };

    togglePassword = (event) => {
        event.preventDefault();
        this.setState({showPassword: !this.state.showPassword});
    };

    toggleOldPassword = (e) => {
        e.preventDefault();
        this.setState({showOldPassword: !this.state.showOldPassword})
    };

    toggleAddUser = () => {
        this.setState({
            addUser: !this.state.addUser
        });
    };

    toggleEditUser = () => {
        this.setState({
            editUser: !this.state.editUser
        });
    };

    toggleChangePassword = () => {
        if (this.state.changePassword) {
            this.setState({showOldPassword: false, showPassword: false})
        }
        this.setState({
            changePassword: !this.state.changePassword,
            cpError: null,
        })
    };

    toggleAddAccount = () => {
        this.setState({
            addAccount: !this.state.addAccount
        });
    };

    toggleEditAccount = () => {
        this.setState({
            editAccount: !this.state.editAccount
        });
    };

    toggleEditProject = () => {
        this.setState({
            editProject: !this.state.editProject
        });
    };

    toggleShowDelete = () => {
        this.setState({
            showDelete: !this.state.showDelete
        });
    };

    toggleShowRevoke = () => {
        this.setState({
            showRevoke: !this.state.showRevoke
        });
    };

    handleEditPassword = e => {
        e.preventDefault();
        this.setState({password: e.target.value});
    };

    handleEditOldPassword = e => {
        e.preventDefault();
        this.setState({oldPassword: e.target.value});
    };

    handleChangePasswordSubmit = ()=> {
        this.props.onChangePassword(this.props.token, this.state.oldPassword, this.state.password)
        this.setState({showOldPassword: false, showPassword: false})
    };

    handleEditUser = (e, id) => {
        e.preventDefault();
        this.setState({editUser: true, editedUser: this.state.users[id], editedUserId: id})
    };

    handleEditAccount = (e, id) => {
        e.preventDefault();
        this.setState({editAccount: true, editedAccount: this.state.accounts[id], editedAccountId: id, accountOrOrg: "account", cloudprovider: 'aws'})
    };

    handleEditOrg = (e, id) => {
        e.preventDefault();
        this.setState({editAccount: true, editedOrg: this.state.orgs[id], editedOrgId : id, accountOrOrg: "organization", cloudprovider: 'aws'})
    };

    handleEditProject = (e, id) => {
        e.preventDefault();
        this.setState({editProject: true, editedProject: this.state.gcpProjects[id], editedProjectId: id, cloudprovider: "gcp"});
    };

    handleDeleteUser = (e, id) => {
        e.preventDefault();
        this.setState({showDelete: true, deletedUser: id})
    };

    handleDeleteAccount = (e, id) => {
        e.preventDefault();
        this.setState({showDelete: true, deletedAccount: id})
    };

    handleDeleteOrg = (e, id) =>  {
        e.preventDefault();
        this.setState({showDelete: true, deletedOrg: id})
    }

    handleDeleteGcpProject = (e, id) => {
        e.preventDefault();
        this.setState({showDelete: true, deletedProject: id})
    }

    handleDeleteSession = (e, id) => {
        e.preventDefault();
        this.setState({showRevoke: true, deletedSession: id})
    };

    handleDeleteApiKey = (e) => {
        e.preventDefault();
        this.setState({showDelete: true, deleteApiKey: true})
    };

    handleGenerateApiKey = (e) => {
        e.preventDefault();
        this.props.onGenerateApiKey(this.props.token)
    };

    handleEditUserName = e => {
        this.setState({editedUser: {...this.state.editedUser, name: e.target.value}})
    };

    handleEditUserEmail = e => {
        this.setState({editedUser: {...this.state.editedUser, email: e.target.value}})
    };

    handleEditUserWeeklyEmail = e => {
        this.setState({editedUser: {...this.state.editedUser, weeklyEmail: !this.state.editedUser.weeklyEmail}})
    };

    handleEditUserReadOnly = e => {
        this.setState({editedUser: {...this.state.editedUser, readOnly: !this.state.editedUser.readOnly}})
    };

    handleEditUserSsoLoginOnly = e => {
        this.setState({editedUser: {...this.state.editedUser, ssoLoginOnly: !this.state.editedUser.ssoLoginOnly}})
    }

    handleAddAccountId = e => {
        this.setState({addedAccount: {...this.state.addedAccount, id: e.target.value}})
    }

    handleAddAccountName = e => {
        this.setState({addedAccount: {...this.state.addedAccount, name: e.target.value}})
    }

    handleAddPartition = e => {
        this.setState({addedAccount: {...this.state.addedAccount, aws_partition: e.target.value}})
    }

    handleCloudprovider = e => {
        this.setState({cloudprovider: e.target.value})
    }

    handleAddAccountEnterpriseDiscount = e => {
        this.setState({addedAccount: {...this.state.addedAccount, discount: this.toFloatNumber(e.target.value)}})
    }

    handleEditAccountId = e => {
        if (this.state.accountOrOrg === "account" || this.state.accountOrOrg === "") {
            this.setState({editedAccount: {...this.state.editedAccount, id: e.target.value}})
        } else {
            this.setState({editedOrg: {...this.state.editedOrg, id: e.target.value}})
        }
    };

    handleEditAccountName = e => {
        if (this.state.accountOrOrg === "account" || this.state.accountOrOrg === "") {
            this.setState({editedAccount: {...this.state.editedAccount, name: e.target.value}})
        } else {
            this.setState({editedOrg: {...this.state.editedOrg, name: e.target.value}})
        }
    }

    handleEditProjectId = e  => {
        this.setState({editedProject: {...this.state.editedProject, id: e.target.value}});
    };

    handleEditProjectName = e => {
        this.setState({editedProject: {...this.state.editedProject, name: e.target.value}});
    };

    handleEditPartition = e => {
        if (this.state.accountOrOrg === "account" || this.state.accountOrOrg === "") {
            this.setState({editedAccount: {...this.state.editedAccount, aws_partition: e.target.value}})
        } else {
            this.setState({editedOrg: {...this.state.editedOrg, aws_partition: e.target.value}})
        }
    }

    handleEditEnterpriseDiscount = e => {
        if (this.state.accountOrOrg === "account" || this.state.accountOrOrg === "") {
            this.setState({editedAccount: {...this.state.editedAccount, discount: this.toFloatNumber(e.target.value)}})
        } else {
            this.setState({editedOrg: {...this.state.editedOrg, discount: this.toFloatNumber(e.target.value)}});
        }
    };

    handleChangeAccountOrOrg = e => {
        this.setState({accountOrOrg: e.target.value})
    }

    handleCancelDelete = () => {
        this.setState({showDelete: false, deletedUser: null, deletedAccount: null, deletedOrg: null, deletedProject: null, deleteApiToken: false})
    };

    handleCancelRevoke = () => {
        this.setState({showRevoke: false, deletedSession: null})
    };

    handleAddUserSubmit = (e) => {
        e.preventDefault();
        let addedUser = {...this.state.editedUser};
        let users = this.state.users.concat(this.state.editedUser);
        this.setState({users: users, addUser: false, editedUser: null});
        this.props.onAddUser(this.props.token, addedUser);
    };

    handleEditUserSubmit = (e) => {
        e.preventDefault();
        let updatedUser = {...this.state.editedUser};
        let users = [...this.state.users.slice(0, this.state.editedUserId), updatedUser, ...this.state.users.slice(this.state.editedUserId + 1)];
        this.setState({users: users, editUser: false, editedUser: null, editedUserId: null});
        this.props.onUpdateUser(this.props.token, updatedUser);
    };

    handleAddAccountSubmit = (e) => {
        e.preventDefault();
        if (this.state.cloudprovider === 'gcp') {
            let gcpProject = {id: this.state.addedAccount.id, name: this.state.addedAccount.name}
            let gcpProjects = this.state.gcpProjects.concat(gcpProject)
            this.setState({gcpProjects: gcpProjects, addAccount: false, addedAccount: null})
            this.props.onUpdateAccount(this.props.token, this.state.accounts, this.state.orgs, gcpProjects)
        } else if (this.state.accountOrOrg === 'account' || this.state.accountOrOrg === "") {
            let accts = this.state.accounts.concat(this.state.addedAccount)
            this.setState({accounts: accts, addAccount: false, addedAccount: null})
            this.props.onUpdateAccount(this.props.token, accts, this.state.orgs, this.state.gcpProjects)
        } else {
            let orgs = this.state.orgs.concat(this.state.addedAccount)
            this.setState({orgs: orgs, addAccount: false, addedAccount: null})
            this.props.onUpdateAccount(this.props.token, this.state.accounts, orgs, this.state.gcpProjects)
        }
    };

    handleEditAccountSubmit = (e) => {
        e.preventDefault();
        if (this.state.accountOrOrg === "account" || this.state.accountOrOrg === "") {
            let accts = [...this.state.accounts.slice(0, this.state.editedAccountId), this.state.editedAccount, ...this.state.accounts.slice(this.state.editedAccountId + 1)];
            this.setState({accounts: accts, editAccount: false, editedAccount: null, editedAccountId: null});
            this.props.onUpdateAccount(this.props.token, accts, this.state.orgs, this.state.gcpProjects)
        } else {
            let orgs = [...this.state.orgs.slice(0, this.state.editedOrgId), this.state.editedOrg, ...this.state.orgs.slice(this.state.editedOrgId +1)]
            this.setState({orgs: orgs, editAccount: false, editedOrg: null, editedOrgId: null});
            this.props.onUpdateAccount(this.props.token, this.state.accounts, orgs, this.state.gcpProjects)
        }
    };

    handleEditProjectSubmit = (e) => {
        e.preventDefault();
        let gcpProjects = [...this.state.gcpProjects.slice(0, this.state.editedProjectId), this.state.editedProject, ...this.state.gcpProjects.slice(this.state.editedProjectId + 1)];
        this.setState({gcpProjects: gcpProjects, editProject: false, editedProject: null, editedProjectId: null});
        this.props.onUpdateAccount(this.props.token, this.state.accounts, this.state.orgs, gcpProjects)
    }

    handleWeeklyEmailDirectly = (e, id) => {
        let editeduser = this.state.users[id];
        let updated = {...editeduser, weeklyEmail: !editeduser.weeklyEmail};
        let users = [...this.state.users.slice(0, id), updated, ...this.state.users.slice(id + 1)];
        this.setState({users: users});
        this.props.onUpdateUser(this.props.token, updated)
    };

    handleReadOnlyDirectly = (e, id) => {
        let editeduser = this.state.users[id];
        let updated = {...editeduser, readOnly: !editeduser.readOnly};
        let users = [...this.state.users.slice(0, id), updated, ...this.state.users.slice(id + 1)];
        this.setState({users: users});
        this.props.onUpdateUser(this.props.token, updated)
    };

    handleSsoLoginDirectly = (e, id) => {
        let editeduser = this.state.users[id];
        let updated = {...editeduser, ssoLoginOnly: !editeduser.ssoLoginOnly};
        let users = [...this.state.users.slice(0, id), updated, ...this.state.users.slice(id + 1)];
        this.setState({users: users});
        this.props.onUpdateUser(this.props.token, updated)
    }

    handleDelete = e => {
        e.preventDefault();
        if (this.state.deletedAccount !== null) {
            let accts = [...this.state.accounts.slice(0, this.state.deletedAccount), ...this.state.accounts.slice(this.state.deletedAccount + 1)];
            this.setState({accounts: accts, showDelete: false, deletedAccount: null});
            this.props.onUpdateAccount(this.props.token, accts, this.state.orgs, this.state.gcpProjects);
        } else if (this.state.deletedOrg !== null) {
            let orgs = [...this.state.orgs.slice(0, this.state.deletedOrg), ...this.state.orgs.slice(this.state.deletedOrg + 1)];
            this.setState({orgs: orgs, showDelete: false, deletedOrg: null});
            this.props.onUpdateAccount(this.props.token, this.state.accounts, orgs, this.state.gcpProjects);
        } else if (this.state.deletedProject !== null) {
            let gcpProjects = [...this.state.gcpProjects.slice(0, this.state.deletedProject), ...this.state.gcpProjects.slice(this.state.deletedProject + 1)];
            this.setState({gcpProject: gcpProjects, showDelete: false, deletedProject: null});
            this.props.onUpdateAccount(this.props.token, this.state.accounts, this.state.orgs, gcpProjects)
        } else if (this.state.deletedUser !== null) {
            let deleted = {...this.state.users[this.state.deletedUser]};
            let users = [...this.state.users.slice(0, this.state.deletedUser), ...this.state.users.slice(this.state.deletedUser + 1)];
            this.setState({users: users, showDelete: false, deletedUser: null});
            this.props.onDeleteUser(this.props.token, deleted);
        } else if (this.state.deleteApiKey) {
            this.setState({showDelete: false, deleteApiKey: false});
            this.props.onDeleteApiKey(this.props.token, this.props.settings.apiKey.key);
        } else if (this.state.deletedScoping !== null) {
            let scopings = [...this.state.scopings.slice(0, this.state.deletedScoping), ...this.state.scopings.slice(this.state.deletedScoping+1)];
            this.setState({scopings: scopings, showDelete: false, deletedScoping: null})
            this.props.onUpdateScopings(this.props.token, scopings);
        }
    };

    handleRevoke = e => {
        let deleted = {...this.state.sessions[this.state.deletedSession]};
        let sessions = [...this.state.sessions.slice(0, this.state.deletedSession), ...this.state.sessions.slice(this.state.deletedSession+1)];
        this.setState({showRevoke: false, deletedSession: null, sessions: sessions});
        this.props.onRevokeSession(this.props.token, deleted.token);
    };

    toggleAddScoping = () => {
        this.setState({
            addScoping: !this.state.addScoping
        })
    };

    toggleEditScoping = () => {
        this.setState({
            editScoping: !this.state.editScoping
        })
    };

    handleEditScoping = (e, id) => {
        e.preventDefault();
        this.setState({editScoping: true, editedScoping: this.state.scopings[id], editedScopingId: id})
    };

    handleDeleteScoping = (e, id) => {
        e.preventDefault();
        this.setState({showDelete: true, deletedScoping: id})
    };

    handleEditScopingTagKey = e => {
        this.setState({editedScoping: {...this.state.editedScoping, tagKey: e.target.value}})
    };

    handleEditScopingDisplayName = e => {
        this.setState({editedScoping: {...this.state.editedScoping, displayName: e.target.value}})
    };

    handleAddScopingSubmit = (e) => {
        e.preventDefault();
        let scopings = this.state.scopings.concat(this.state.editedScoping);
        this.setState({scopings: scopings, addScoping: false, editedScoping: null});
        this.props.onUpdateScopings(this.props.token, scopings)
    };

    handleEditScopingSubmit = (e) => {
        e.preventDefault();
        let scopings = [...this.state.scopings.slice(0, this.state.editedScopingId), this.state.editedScoping, ...this.state.scopings.slice(this.state.editedScopingId+1)];
        this.setState({scopings: scopings, editScoping: false, editedScoping: null, editedScopingId: null});
        this.props.onUpdateScopings(this.props.token, scopings)
    };

    shortenString = (s) => {
        let l = s.length;
        return '...' + s.substring(l - 16)
    };

    componentDidMount() {
        window.$(function () {
            window.jcf.replaceAll();
        });

        window.$(function () {

            window.$('[data-toggle="offcanvas"]').on('click', function () {
                window.$('.offcanvas-collapse').toggleClass('open')
            })
        });
        this.stateSelect = this.refs.stateSelect
        setTimeout(() => {
            if (window.jcf.getInstance(this.stateSelect) && window.jcf.getInstance(this.stateSelect).instance) {
                window.jcf.getInstance(this.stateSelect).instance.delayedRefresh()
            }
            if (this.state.ssoEnabled) {
                window.$("#defaultUserTypeSelect").val(this.state.defaultUserType);
                let ut = window.jcf.getInstance(window.$("#defaultUserTypeSelect"));
                if (ut) {ut.refresh()}
            }
        }, 500)
    }

    componentWillMount() {
        this.props.onFetchSettings(this.props.token);
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            company: props.settings.company,
            phone: props.settings.phone,
            street: props.settings.address ? props.settings.address.street : '',
            unit: props.settings.address ? props.settings.address.unit : '',
            city: props.settings.address ? props.settings.address.city : '',
            state: props.settings.address ? props.settings.address.state : '',
            zip: props.settings.address ? props.settings.address.zip : '',
            accounts: props.settings.accounts ? props.settings.accounts : [],
            orgs: props.settings.orgs? props.settings.orgs: [],
            gcpProjects: props.settings.gcpProjects? props.settings.gcpProjects: [],
            users: props.settings.users ? props.settings.users : [],
            sessions: props.settings.userSessions ? props.settings.userSessions: [],
            scopings: props.settings.scopings? props.settings.scopings: [],
            ssoEnabled: props.settings.ssoConfig? props.settings.ssoConfig.ssoEnabled: false,
            spConfigMode: (props.settings.ssoConfig && props.settings.ssoConfig.idpSsoUrl) ?  SpecifyFieldValues : MetadataUrl,
            idpSsoUrl: props.settings.ssoConfig? props.settings.ssoConfig.idpSsoUrl: '',
            idpIssuer: props.settings.ssoConfig? props.settings.ssoConfig.idpIssuer: '',
            idpMetadataUrl: props.settings.ssoConfig? props.settings.ssoConfig.idpMetadataUrl: '',
            idpMetadataXml: props.settings.ssoConfig? props.settings.ssoConfig.idpMetadataXml: '',
            idpCertificateData: props.settings.ssoConfig? props.settings.ssoConfig.idpCertificateData: "",
            certExpiration: props.settings.ssoConfig? props.settings.ssoConfig.certExpiration: null,
            defaultUserType: (props.settings.ssoConfig && props.settings.ssoConfig.defaultReadonly) ? ReadOnlyUser : User,
            emailAddrAttribute: props.settings.ssoConfig && props.settings.ssoConfig.attributesMapping ? props.settings.ssoConfig.attributesMapping.EmailAddr: '',
            spKeyAndCertCreated: props.settings.ssoConfig ? props.settings.ssoConfig.spKeyAndCertCreated : false,
            guid: props.settings.spMetadata? props.settings.spMetadata.defaultRelayState : "",
            cpError: props.cpError,
        });
        if (this.state.changePassword && props.cpError === null && props.fromPost) {
            this.setState({changePassword: !this.state.changePassword})
        }

        setTimeout(() => {
            window.$(function () {
                window.jcf.replaceAll();
            });
            if (window.jcf.getInstance(this.stateSelect) && window.jcf.getInstance(this.stateSelect).instance) {
                window.jcf.getInstance(this.stateSelect).instance.delayedRefresh()
            }
            if (this.state.ssoEnabled) {
                window.$("#defaultUserTypeSelect").val(this.state.defaultUserType);
                let ut = window.jcf.getInstance(window.$("#defaultUserTypeSelect"));
                if (ut) {ut.refresh()}
            }
        }, 100)
    }

    redirectToDashboard = (event) => {
        event.preventDefault();
        this.props.history.push("/dashboard")
    };

    redirectToGcpDashboard = (event) => {
        event.preventDefault();
        this.props.history.push("/gcpDashboard")
    };

    redirectToInstallation = (event) => {
        event.preventDefault();
        this.props.history.push("/installation")
    };

    redirectToXogroups = (event) => {
        event.preventDefault();
        this.props.history.push("/xogroups")
    };

    redirectToScheduler = (e) => {
        e.preventDefault();
        this.props.history.push("/schedulers")
    };

    redirectToBudget = (e) => {
        e.preventDefault();
        this.props.history.push("/budgets")
    };

    redirectToAlerts = (e) => {
        e.preventDefault();
        this.props.history.push("/alerts")
    }

    handleInputChange = (event, inputName) => {
        this.setState({[inputName]: event.target.value})
    };

    handleStateChange = (e) => {
        this.setState({"state": e.target.value})
    };

    handleLogout = () => {
        // this.setState({logoutClicked: true});
        this.props.onLogout(this.props.token)
    };

    handleCompanyCancel = (event) => {

        event.preventDefault();

        this.setState({
            company: this.props.settings.company,
            phone: this.props.settings.phone,
            street: this.props.settings.address ? this.props.settings.address.street : '',
            unit: this.props.settings.address ? this.props.settings.address.unit : '',
            city: this.props.settings.address ? this.props.settings.address.city : '',
            state: this.props.settings.address ? this.props.settings.address.state : '',
            zip: this.props.settings.address ? this.props.settings.address.zip : '',
        });

        setTimeout(() => {
            window.jcf.getInstance(this.stateSelect).instance.refreshSelectedText()
        }, 100)
    };

    componentWillUnmount() {
        if (window.jcf.getInstance(this.stateSelect)) {
            window.jcf.getInstance(this.stateSelect).instance.destroy();
        }
    }

    handleCompanySave = (event) => {
        event.preventDefault();
        this.props.onSaveCompanyInfo(this.props.token, {
            company: this.state.company,
            phone: this.state.phone,
            address: {
                street: this.state.street,
                unit: this.state.unit,
                city: this.state.city,
                state: this.state.state,
                zip: this.state.zip
            },
            action: "updateCompany"
        })
    };

    handleSsoEnabled = (event) => {
        this.setState({ssoEnabled: event.target.checked}, () => {
            this.props.onSaveSsoConfig(this.props.token, {
                ssoEnabled: this.state.ssoEnabled,
                action: "enableSsoConfig",
            })
        })
    }

    handleSpConfigMode = (event) => {
        this.setState({spConfigMode: event.target.value})
    }

    handleIdpConfigMode = (event) => {
        this.setState({idpConfigMode: event.target.value})
    }

    handleDefaultUserTypeChange = (event) => {
        this.setState({defaultUserType: event.target.value})
    }

    handleFileChange = (event, fileKey, dataKey) => {
        this.setState({[fileKey]: event.target.files[0]});

        let fileReader;
        const handleFileRead = (e) => {
            const content = fileReader.result;
            this.setState({[dataKey]: content});
        }

        fileReader = new FileReader();
        fileReader.onloadend = handleFileRead;
        fileReader.readAsText(event.target.files[0]);
    };

    handleSsoCancel = (event) => {
        event.preventDefault();
        let userType = User
        if (this.props.settings.ssoConfig && this.props.settings.ssoConfig.defaultReadonly) {
            userType = ReadOnlyUser
        }
        this.setState({
            ssoEnabled: this.props.settings.ssoConfig? this.props.settings.ssoConfig.ssoEnabled: false,
            spConfigMode: (this.props.settings.ssoConfig && this.props.settings.ssoConfig.idpSsoUrl) ? SpecifyFieldValues: MetadataUrl,
            idpConfigMode: MetadataUrl,
            idpSsoUrl: this.props.settings.ssoConfig? this.props.settings.ssoConfig.idpSsoUrl: '',
            idpIssuer: this.props.settings.ssoConfig? this.props.settings.ssoConfig.idpIssuer: '',
            idpMetadataUrl: this.props.settings.ssoConfig? this.props.settings.ssoConfig.idpMetadataUrl: '',
            idpMetadataXml: this.props.settings.ssoConfig? this.props.settings.ssoConfig.idpMetadataXml: '',
            idpCertificateData: this.props.settings.ssoConfig? this.props.settings.ssoConfig.idpCertificateData: '',
            certExpiration: this.props.settings.ssoConfig? this.props.settings.ssoConfig.certExpiration: null,
            emailAddrAttribute: this.props.settings.ssoConfig && this.props.settings.ssoConfig.attributesMapping ? this.props.settings.ssoConfig.attributesMapping.EmailAddr: '',
            defaultUserType: userType,
        });
    }

    handleSsoSave = (event) => {
        event.preventDefault();
        let emailAttribute = this.state.emailAddrAttribute
        let attr = null
        if (emailAttribute !== null && emailAttribute !== "") {
            attr = {EmailAddr: emailAttribute}
        }
        this.props.onSaveSsoConfig(this.props.token, {
            ssoEnabled: this.state.ssoEnabled,
            spConfigMode: this.state.spConfigMode,
            idpSsoUrl: this.state.idpSsoUrl,
            idpIssuer: this.state.idpIssuer,
            idpMetadataUrl: this.state.idpMetadataUrl,
            idpMetadataXml: this.state.idpMetadataXml,
            idpCertificateData: this.state.idpCertificateData,
            attributesMapping: attr,
            defaultReadonly: this.state.defaultUserType !== User,
            action: "updateSsoConfig",
        })
    }

    copyToClipbooard = (id) => {
        var copyText = document.getElementById(id);
        if (copyText) {
            copyText.select();
            copyText.setSelectionRange(0, 99999); /* For mobile devices */
            navigator.clipboard.writeText(copyText.value);
        }
    }

    downloadUrl = (url, filename) => {
        this.setState({ loading: true }, () => {
            fetch(url).then(async response => {
                const data = await response.text();
                if (!response.ok) {
                    // get error message from body or default to response statusText
                    const error = (data && data.message) || response.statusText;
                    return Promise.reject(error);
                }

                var element = document.createElement('a');
                element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data));
                element.setAttribute('download', filename);
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            })
            .catch(error => {
                this.setState({ errorMessage: error.toString() });
            });
        });
    }

    render() {
        return (
            <div>
                <div className="wrapper">
                    <Loader fullPage={true} loading={this.props.loading}/>
                    <div className="navbar navbar-dark bg-dark d-block d-md-none mob-nav fixed-top">
                        <button className="navbar-toggler pull-right" type="button" data-toggle="offcanvas"><span
                            className="navbar-toggler-icon"></span></button>
                        <div className="nav-item dropdown logo pull-left"><a className="dropdown-toggle text-white"
                                                                             href="http://example.com" id="dropdown10"
                                                                             data-toggle="dropdown" aria-haspopup="true"
                                                                             aria-expanded="false">
                            <div className="company-logo">
                                <div className="inner-logo rounded-circle img-thumbnail"><img src={maleAvatar}
                                                                                              alt="" title=""/></div>
                            </div>
                            {this.props.company}</a>
                            <div className="dropdown-menu" aria-labelledby="dropdown10">
                                <a className="dropdown-item" href="#">{this.props.company}</a>
                                <a className="dropdown-item" href="#" onClick={this.handleLogout}>Logout</a></div>
                        </div>
                    </div>
                    <div className="sidebar offcanvas-collapse">
                        <div className="sidebar-wrapper">
                            <div className="dropdown logo d-none d-md-block"><a href="/"
                                                                                className="simple-text dropdown-toggle"
                                                                                data-toggle="collapse"
                                                                                data-target="#dropdown11">
                                <div className="company-logo">
                                    <div className="inner-logo rounded-circle img-thumbnail"><img
                                        src={maleAvatar} alt="" title=""/></div>
                                </div>
                                {this.props.company} </a>
                                <div className="dropdown-menu collapse" id="dropdown11">
                                    <a className="dropdown-item" href="#">{this.props.company}</a>
                                    <a className="dropdown-item" href="#" onClick={this.handleLogout}>Logout</a>
                                </div>
                            </div>
                            <ul className="nav">
                                {
                                    this.props.gcpOnly ? null :
                                        (<li><a href="#" onClick={this.redirectToDashboard}> <i className="fa fa-bar-chart"></i>
                                            <p>AWS Dashboard</p>
                                        </a></li>)
                                }
                                {
                                    this.props.hasGcp ?
                                        (
                                            <li><a href="#" onClick={this.redirectToGcpDashboard}> <i className="fa fa-bar-chart"></i>
                                                <p>GCP Dashboard</p>
                                            </a></li>
                                        ) : null
                                }
                                <li><a href="#" onClick={this.redirectToXogroups}> <i className="com-icon"><img
                                    src={computerIcon} alt="" title=""/></i>
                                    <p>Xogroups</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToBudget}> <i className="fa fa-dollar"></i>
                                    <p>Budgets</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToScheduler}> <i className="fa fa-calendar"></i>
                                    <p>Schedules</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToAlerts}> <i className="com-icon"><img
                                    src={alertsIcon} alt="" title="" width="25"/></i>
                                    <p>Alerts</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToInstallation}> <i className="fa fa-wrench"></i>
                                    <p>Installation</p>
                                </a></li>
                                <li className="active"><a href="#"> <i className="fa fa-gear"></i>
                                    <p>Settings</p>
                                </a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-panel">
                        <div className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-12">
                                        <Error errorMsg={this.props.error} divClass="col-lg-5 col-sm-6 col-center"/>
                                        <div className="card">
                                            <div className="content">
                                                <div className="header">
                                                    <h4 className="title mb-3">Account Settings</h4>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xl-8 col-lg-10">
                                                        <div className="row form-group">
                                                            <div className="col-sm-5 label text-right">
                                                                <label>Company Name:</label>
                                                            </div>
                                                            <div className="col-sm-7">
                                                                <input type="text" className="form-control"
                                                                       placeholder="Company" disabled={this.isReadOnly()}
                                                                       onChange={e => this.handleInputChange(e, "company")}
                                                                       value={this.state.company || ''}/>
                                                            </div>
                                                        </div>
                                                        <div className="row form-group">
                                                            <div className="col-sm-5 label text-right">
                                                                <label>Address:</label>
                                                            </div>
                                                            <div className="col-sm-7">
                                                                <input type="text" className="form-control"
                                                                       placeholder="Street and number" disabled={this.isReadOnly()}
                                                                       onChange={e => this.handleInputChange(e, "street")}
                                                                       value={this.state.street || ''}/>
                                                            </div>
                                                        </div>
                                                        <div className="row form-group">
                                                            <div className="col-sm-5"></div>
                                                            <div className="col-sm-7">
                                                                <input type="text" className="form-control"
                                                                       placeholder="Apartment, suite, unit, building, floor, etc."
                                                                       disabled={this.isReadOnly()}
                                                                       onChange={e => this.handleInputChange(e, "unit")}
                                                                       value={this.state.unit || ''}/>
                                                            </div>
                                                        </div>
                                                        <div className="row form-group">
                                                            <div className="col-sm-5"></div>
                                                            <div className="col-sm-7">
                                                                <input type="text" className="form-control"
                                                                       placeholder="City"
                                                                       disabled={this.isReadOnly()}
                                                                       onChange={e => this.handleInputChange(e, "city")}
                                                                       value={this.state.city || ''}/>
                                                            </div>
                                                        </div>
                                                        <div className="row form-group">
                                                            <div className="col-sm-5"></div>
                                                            <div className="col-sm-7">
                                                                <select value={this.state.state}
                                                                        disabled={this.isReadOnly()}
                                                                        onChange={e => this.handleStateChange(e)}
                                                                        ref="stateSelect">
                                                                    <option value='' disabled>State</option>
                                                                    {
                                                                        stateOptions.map((s, index) => {
                                                                            return (
                                                                                <option key={index}
                                                                                        value={s.value}>{s.label}</option>
                                                                            )
                                                                        })
                                                                    }
                                                                </select>

                                                            </div>
                                                        </div>
                                                        <div className="row form-group">
                                                            <div className="col-sm-5"></div>
                                                            <div className="col-sm-7">
                                                                <input type="text" className="form-control"
                                                                       placeholder="Zip code"
                                                                       disabled={this.isReadOnly()}
                                                                       onChange={e => this.handleInputChange(e, "zip")}
                                                                       value={this.state.zip || ''}/>
                                                            </div>
                                                        </div>
                                                        <div className="row form-group">
                                                            <div className="col-sm-5 label text-right">
                                                                <label>Phone Number:</label>
                                                            </div>
                                                            <div className="col-sm-7">
                                                                <input type="text" className="form-control"
                                                                       placeholder="Phone number"
                                                                       disabled={this.isReadOnly()}
                                                                       onChange={e => this.handleInputChange(e, "phone")}
                                                                       value={this.state.phone || ''}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12 text-right">
                                                        <button type="submit" className="btn btn-light" disabled={this.isReadOnly()}
                                                                onClick={e => this.handleCompanyCancel(e)}>Cancel
                                                        </button>
                                                        <button type="submit" className="btn btn-primary ml-2" disabled={this.isReadOnly()}
                                                                onClick={e => this.handleCompanySave(e)}>Save
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card">
                                            <div className="content">
                                                <div className="header">
                                                    <div className="row no-gutters">
                                                        <div className="col-6">
                                                            <h4 className="title mt-2 mb-3">Cloud Authorizations</h4>
                                                        </div>
                                                        <div className="col-6 text-right">
                                                            <button type="button" className="btn btn-secondary btn-add-acct-org"
                                                                    data-toggle="modal" data-target="#addaccount" disabled={this.isReadOnly()}
                                                                    onClick={e => this.setState({addAccount: true, cloudprovider: 'aws'})}>Add
                                                                Authorization
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <table width="100%" cellPadding="0" cellSpacing="0"
                                                       className="table alt-rows responsive-table">
                                                    <thead>
                                                    <tr>
                                                        <th>Cloud Provider</th>
                                                        <th>Entity Type</th>
                                                        <th>Name</th>
                                                        <th>ID</th>
                                                        <th>Discount</th>
                                                        <th className="text-center">Edit</th>
                                                        <th className="text-center">Delete</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        this.state.accounts.map((a, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td data-title="Cloud Provider">{a.aws_partition === 'aws-us-gov'? "AWS GovCloud" : "AWS"}</td>
                                                                    <td data-title="Entity Type">Account</td>
                                                                    <td data-title="Name"
                                                                        className="email-col">{a.name}</td>
                                                                    <td data-title="ID"
                                                                        className="email-col">{a.id}</td>
                                                                    <td data-title="Discount">{this.formatPercent(a.discount)}%</td>
                                                                    <td data-title="Edit" align="center"><a
                                                                        href="#"
                                                                        onClick={e => {
                                                                            if (this.isReadOnly()) {
                                                                                return false;
                                                                            } else {
                                                                                this.handleEditAccount(e, index)
                                                                            }
                                                                        }}
                                                                        className="text-primary"
                                                                        data-toggle="modal"
                                                                        data-target="#editAccount"><i
                                                                        className="fa fa-edit fa-x"></i></a></td>
                                                                    <td data-title="Delete" align="center"><a href="#"
                                                                                                              onClick={(e) => {
                                                                                                                  if (this.isReadOnly()) {
                                                                                                                      return false;
                                                                                                                  } else {
                                                                                                                      this.handleDeleteAccount(e, index)
                                                                                                                  }
                                                                                                              }}
                                                                                                              className="text-primary"
                                                                                                              data-toggle="modal"
                                                                                                              data-target="#deleteitem"><i
                                                                        className="fa fa-trash-o fa-x"></i></a></td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    {
                                                        this.state.orgs.map((o, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td data-title="Cloud Provider">{o.aws_partition === 'aws-us-gov'? "AWS GovCloud" : "AWS"}</td>
                                                                    <td data-title="Entity Type">Organization</td>
                                                                    <td data-title="Name"
                                                                        className="email-col">{o.name}</td>
                                                                    <td data-title="ID"
                                                                        className="email-col">{o.id}</td>
                                                                    <td data-title="Discount">{this.formatPercent(o.discount)}%</td>
                                                                    <td data-title="Edit" align="center"><a
                                                                        href="#"
                                                                        onClick={e => {
                                                                            if (this.isReadOnly()) {
                                                                                return false;
                                                                            } else {
                                                                                this.handleEditOrg(e, index)
                                                                            }
                                                                        }}
                                                                        className="text-primary"
                                                                        data-toggle="modal"
                                                                        data-target="#editAccount"><i
                                                                        className="fa fa-edit fa-x"></i></a></td>
                                                                    <td data-title="Delete" align="center"><a href="#"
                                                                                                              onClick={(e) => {
                                                                                                                  if (this.isReadOnly()) {
                                                                                                                      return false;
                                                                                                                  } else {
                                                                                                                      this.handleDeleteOrg(e, index)
                                                                                                                  }
                                                                                                              }}
                                                                                                              className="text-primary"
                                                                                                              data-toggle="modal"
                                                                                                              data-target="#deleteitem"><i
                                                                        className="fa fa-trash-o fa-x"></i></a></td>
                                                                </tr>
                                                        )
                                                    })
                                                    }
                                                    {
                                                        this.state.gcpProjects.map((p, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td data-title="Cloud Provider">GCP</td>
                                                                    {/*<td data-title="Partition"></td>*/}
                                                                    <td data-title="Entity Type">Project</td>
                                                                    <td data-title="Name"
                                                                        className="email-col">{p.name}</td>
                                                                    <td data-title="ID"
                                                                        className="email-col">{p.id}</td>
                                                                    <td data-title="Discount"></td>
                                                                    <td data-title="Edit" align="center"><a
                                                                        href="#"
                                                                        onClick={e => {
                                                                            if (this.isReadOnly()) {
                                                                                return false;
                                                                            } else {
                                                                                this.handleEditProject(e, index)
                                                                            }
                                                                        }}
                                                                        className="text-primary"
                                                                        data-toggle="modal"
                                                                        data-target="#editProject"><i
                                                                        className="fa fa-edit fa-x"></i></a></td>
                                                                    <td data-title="Delete" align="center"><a href="#"
                                                                                                              onClick={(e) => {
                                                                                                                  if (this.isReadOnly()) {
                                                                                                                      return false;
                                                                                                                  } else {
                                                                                                                      this.handleDeleteGcpProject(e, index)
                                                                                                                  }
                                                                                                              }}
                                                                                                              className="text-primary"
                                                                                                              data-toggle="modal"
                                                                                                              data-target="#deleteitem"><i
                                                                        className="fa fa-trash-o fa-x"></i></a></td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>


                                        <div className="card">
                                            <div className="content">
                                                <div className="header">
                                                    <div className="row">
                                                        <div className="col-3">
                                                            <h4 className="title mt-2 mb-3">Users</h4>
                                                        </div>
                                                        <div className="col-9 text-right">
                                                            <button type="button" className="btn btn-secondary"
                                                                    data-toggle="modal" data-target="#adduser" disabled={this.isReadOnly()}
                                                                    onClick={e => this.setState({
                                                                        addUser: true,
                                                                        editedUser: {
                                                                            ...this.state.editedUser,
                                                                            weeklyEmail: true
                                                                        }
                                                                    })}>Add
                                                                User
                                                            </button>
                                                            <button type="button" className="btn btn-secondary btn-add-tag"
                                                                    data-toggle="modal" data-target="#changepassword"
                                                                    onClick={e => this.setState({
                                                                        changePassword: true}
                                                                    )}>Change Password
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <table width="100%" cellPadding="0" cellSpacing="0"
                                                       className="table alt-rows responsive-table">
                                                    <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Email</th>
                                                        <th className="text-center">Weekly Email</th>
                                                        <th className="text-center">Read-only</th>
                                                        <th className="text-center">Allow Password Login</th>
                                                        <th className="text-center">Edit</th>
                                                        <th className="text-center">Delete</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        this.state.users.map((u, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td data-title="Name">{u.name}</td>
                                                                    <td data-title="Email"
                                                                        className="email-col">{u.email}</td>
                                                                    <td data-title="Weekly Email" align="center"
                                                                        width="130"><input
                                                                        type="checkbox" defaultChecked={u.weeklyEmail} disabled={this.isReadOnly()}
                                                                        onClick={(e) => this.handleWeeklyEmailDirectly(e, index)}/>
                                                                    </td>
                                                                    <td data-title="Readonly" align="center"
                                                                        width="130"><input
                                                                        type="checkbox" defaultChecked={u.readOnly} disabled={this.isReadOnly()}
                                                                        onClick={(e) => this.handleReadOnlyDirectly(e, index)}/>
                                                                    </td>
                                                                    <td data-title="SsoLoginOnly" align="center"
                                                                        with="130"><input
                                                                        type="checkbox" defaultChecked={!u.ssoLoginOnly} disabled={this.isReadOnly()}
                                                                        onClick={(e) => this.handleSsoLoginDirectly(e, index)}/>
                                                                    </td>
                                                                    <td data-title="Edit" align="center" width="80">
                                                                        <a href="#"
                                                                           onClick={e => {if (this.isReadOnly())  {return false;} else {this.handleEditUser(e, index)}}}
                                                                           className="text-primary"
                                                                           data-toggle="modal"
                                                                           data-target="#edituser"><i
                                                                            className="fa fa-edit fa-x"></i></a>
                                                                    </td>
                                                                    <td data-title="Delete" align="center" width="80">
                                                                        {!u.undeletable ? (
                                                                            <a
                                                                                href="#"
                                                                                onClick={(e) => {if (this.isReadOnly())  {return false;} else {this.handleDeleteUser(e, index)}}}
                                                                                className="text-primary"
                                                                                data-toggle="modal"
                                                                                data-target="#deleteitem"><i
                                                                                className="fa fa-trash-o fa-x"></i></a>
                                                                        ) : null
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div className="card">
                                            <div className="content">
                                                <div className="header">
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <h4 className="title mt-2 mb-3">API Key</h4>
                                                        </div>
                                                        <div className="col-6 text-right">
                                                            <button type="button" className="btn btn-secondary" disabled={this.isReadOnly() || this.props.settings.apiKey}
                                                                    onClick={e => this.handleGenerateApiKey(e)}>Create API Key
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <table width="100%" cellPadding="0" cellSpacing="0"
                                                       className="table alt-rows responsive-table">
                                                    <thead>
                                                    <tr>
                                                        <th>API key ID</th>
                                                        <th>Created</th>
                                                        <th align="center">Last used</th>
                                                        <th className="text-center">Delete</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>{
                                                        this.props.settings.apiKey ?  (
                                                                <tr>
                                                                    <td data-title="API key ID">{this.props.settings.apiKey.key}</td>
                                                                    <td data-title="Created"
                                                                        className="email-col">{this.formatDate(this.props.settings.apiKey.createdTs)}</td>
                                                                    <td data-title="Last Used" className="email-col"> {this.formatDate(this.props.settings.apiKey.lastUsedTs)}</td>
                                                                    <td data-title="Delete" align="center" width="80">
                                                                            <a
                                                                                href="#"
                                                                                onClick={(e) => {if (this.isReadOnly())  {return false;} else {this.handleDeleteApiKey(e)}}}
                                                                                className="text-primary"
                                                                                data-toggle="modal"
                                                                                data-target="#deleteitem"><i
                                                                                className="fa fa-trash-o fa-x"></i></a>
                                                                    </td>
                                                                </tr>
                                                            ) : null
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div className="card">
                                            <div className="content">
                                                <div className="header">
                                                    <h4 className="title mb-3">User Sessions</h4>
                                                </div>
                                                <table width="100%" cellPadding="0" cellSpacing="0"
                                                       className="table alt-rows responsive-table">
                                                    <thead>
                                                    <tr>
                                                        <th>Session Token</th>
                                                        <th>Client Ip</th>
                                                        <th>Login Time</th>
                                                        <th className="text-center">Revoke</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        this.state.sessions.map((s, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td data-title="API key ID">{this.shortenString(s.token)}</td>
                                                                    <td data-title="Last Used" className="email-col"> {s.ipAddr}</td>
                                                                    <td data-title="Created"
                                                                        className="email-col">{this.formatDate(s.loginAt)}</td>
                                                                    <td data-title="Delete" align="center" width="80">
                                                                        <a href="#"
                                                                            onClick={(e) => {this.handleDeleteSession(e, index)}}
                                                                            className="text-primary"
                                                                            data-toggle="modal"
                                                                            data-target="#deleteitem"><i
                                                                            className="fa fa-trash-o fa-x"></i></a></td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div className="card">
                                            <div className="content">
                                                <div className="header">
                                                    <div className="row no-gutters">
                                                        <div className="col-6">
                                                            <h4 className="title mt-2 mb-3">Dashboard Scopes</h4>
                                                        </div>
                                                        <div className="col-6 text-right">
                                                            <button type="button" className="btn btn-secondary"
                                                                    data-toggle="modal" data-target="#addscoping" disabled={this.isReadOnly()}
                                                                    onClick={e => this.setState({addScoping: true})}>Add
                                                                Scope
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <table width="100%" cellPadding="0" cellSpacing="0"
                                                       className="table alt-rows responsive-table">
                                                    <thead>
                                                    <tr>
                                                        <th>Tag Key</th>
                                                        <th>Display Name</th>
                                                        <th className="text-center">Edit</th>
                                                        <th className="text-center">Delete</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        this.state.scopings.map((s, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td data-title="Tag Key">{s.tagKey}</td>
                                                                    <td data-title="Display Name" className="email-col"> {s.displayName}</td>
                                                                    <td data-title="Edit" align="center" width="80">
                                                                        <a href="#"
                                                                           onClick={e => {if (this.isReadOnly())  {return false;} else {this.handleEditScoping(e, index)}}}
                                                                           className="text-primary"
                                                                           data-toggle="modal"
                                                                           data-target="#editscoping"><i
                                                                            className="fa fa-edit fa-x"></i></a>
                                                                    </td>
                                                                    <td data-title="Delete" align="center" width="80">
                                                                        <a
                                                                            href="#"
                                                                            onClick={(e) => {
                                                                                if (this.isReadOnly()) {
                                                                                    return false;
                                                                                } else {
                                                                                    this.handleDeleteScoping(e, index)
                                                                                }
                                                                            }}
                                                                            className="text-primary"
                                                                            data-toggle="modal"
                                                                            data-target="#deleteitem"><i
                                                                            className="fa fa-trash-o fa-x"></i></a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div className="card">
                                            <div className="content">
                                                <div className="header">
                                                    <div className="row no-gutters">
                                                        <div className="col-6">
                                                            <h4 className="title mt-2 mb-3">SAML Configuration</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xl-8 col-lg-10">
                                                        <div className="row form-group">
                                                            <div className="col-sm-5 label text-right">
                                                                <label>Enabled:</label>
                                                            </div>
                                                            <div className="col-lg-7 col-md-6 d-flex align-items-center">
                                                                <label className="switch mb-0">
                                                                    <input type="checkbox" className="jcf-ignore"
                                                                           disabled={this.isReadOnly()}
                                                                           checked={!!this.state.ssoEnabled}
                                                                           onChange={e => this.handleSsoEnabled(e)}></input>
                                                                    <div className="slider round"></div>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        {
                                                            this.state.spKeyAndCertCreated && this.state.ssoEnabled &&
                                                        <div>
                                                            <div>&nbsp;</div>
                                                            <div className="row form-group">
                                                                <div className="col-sm-12 label bold">
                                                                    <b className="title mt-2 mb-3">Use the information below to configure the Xosphere Dashboard application in your SAML Identity Provider.</b>
                                                                </div>
                                                            </div>
                                                            <div className="row form-group">
                                                                <div className="col-sm-5 label text-right">
                                                                    <label>Identity Provider (IdP) Configuration Mode:</label>
                                                                </div>
                                                                <div className="col-sm-7">
                                                                    <div className="custom-control custom-radio d-block">
                                                                        <input type="radio" id="idp-config-mode-metadata-url" name="idpConfigModes"
                                                                               disabled={this.isReadOnly()}
                                                                               checked={this.state.idpConfigMode === MetadataUrl ? true : false}
                                                                               value={MetadataUrl}
                                                                               className="custom-control-input"
                                                                               onChange={this.handleIdpConfigMode} />
                                                                        <label className="custom-control-label" htmlFor="idp-config-mode-metadata-url">Metadata URL</label>
                                                                    </div>
                                                                    <div className="custom-control custom-radio d-block">
                                                                        <input type="radio" id="idp-config-mode-metadata-file" name="idpConfigModes"
                                                                               disabled={this.isReadOnly()}
                                                                               checked={this.state.idpConfigMode === MetadataFile ? true : false}
                                                                               value={MetadataFile}
                                                                               className="custom-control-input"
                                                                               onChange={this.handleIdpConfigMode} />
                                                                        <label className="custom-control-label" htmlFor="idp-config-mode-metadata-file">Metadata File</label>
                                                                    </div>
                                                                    <div className="custom-control custom-radio d-block">
                                                                        <input type="radio" id="idp-config-mode-specify-field-values" name="idpConfigModes"
                                                                               disabled={this.isReadOnly()}
                                                                               checked={this.state.idpConfigMode === SpecifyFieldValues ? true : false}
                                                                               value={SpecifyFieldValues}
                                                                               className="custom-control-input"
                                                                               onChange={this.handleIdpConfigMode} />
                                                                        <label className="custom-control-label" htmlFor="idp-config-mode-specify-field-values">Specify Field Values</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {
                                                                this.state.idpConfigMode === MetadataUrl ? (
                                                                <div id="sp-config-metadata-url">
                                                                    <div className="row form-group">
                                                                        <div className="col-sm-5 label text-right">
                                                                            <label>SP Metadata URL:</label>
                                                                        </div>
                                                                        <div className="col-sm-7">
                                                                            <input type="text" className="form-control"
                                                                                   id="sp-metadata-url"
                                                                                   placeholder="SP Metadata URL"
                                                                                   disabled="{true}"
                                                                                   value={API_HOST + "/saml-metadata?guid=" + this.state.guid}/>
                                                                            <button className="btn btn-light"
                                                                                    onClick={() => this.copyToClipbooard('sp-metadata-url')}>Copy
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                ) : null
                                                            }
                                                            {
                                                                this.state.idpConfigMode === MetadataFile ? (
                                                                <div id="sp-config-metadata-file">
                                                                    <div className="row form-group">
                                                                        <div className="col-sm-5 label text-right">
                                                                            <label>SP Metadata XML:</label>
                                                                        </div>
                                                                        <div className="col-sm-7">
                                                                            <button className="btn btn-light"
                                                                                    onClick={() => this.downloadUrl(API_HOST + '/saml-metadata?guid=' + this.state.guid, 'sp-metadata.xml')}>Download
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                ) : null
                                                            }
                                                            {
                                                                this.state.idpConfigMode === SpecifyFieldValues ? (
                                                                <div id="sp-config-specify-field-values"
                                                                     className={this.state.idpConfigMode === SpecifyFieldValues ? undefined : 'hide'}>
                                                                    <div className="row form-group">
                                                                        <div className="col-sm-5 label text-right">
                                                                            <label>SP ACS URL:</label>
                                                                        </div>
                                                                        <div className="col-sm-7">
                                                                            <input type="text" className="form-control"
                                                                                   id="sp-acs-url"
                                                                                   placeholder="SP ACS URL"
                                                                                   disabled={true}
                                                                                   value={this.props.settings.spMetadata ? this.props.settings.spMetadata.acsUrl : ''}/>
                                                                            <button className="btn btn-light"
                                                                                    onClick={() => this.copyToClipbooard('sp-acs-url')}>Copy
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row form-group">
                                                                        <div className="col-sm-5 label text-right">
                                                                            <label>SP Audience URI:</label>
                                                                        </div>
                                                                        <div className="col-sm-7">
                                                                            <input type="text" className="form-control"
                                                                                   id="sp-audience-uri"
                                                                                   placeholder="SP Audience URI"
                                                                                   disabled={true}
                                                                                   value={this.props.settings.spMetadata ? this.props.settings.spMetadata.audienceUrl : ''}/>
                                                                            <button className="btn btn-light"
                                                                                    onClick={() => this.copyToClipbooard('sp-audience-uri')}>Copy
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row form-group">
                                                                        <div className="col-sm-5 label text-right">
                                                                            <label>SP Certificate:</label>
                                                                        </div>
                                                                        <div className="col-sm-7">
                                                                            <button className="btn btn-light"
                                                                                    onClick={() => this.downloadUrl(API_HOST + "/saml-metadata?cert=true&guid=" + this.state.guid, 'sp-certificate.pem')}>Download
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                ): null
                                                            }
                                                            <div className="row form-group">
                                                                <div className="col-sm-5 label text-right">
                                                                    <label>SP Default Relay State:</label>
                                                                </div>
                                                                <div className="col-sm-7">
                                                                    <input type="text" className="form-control"
                                                                           id="sp-default-relay-state"
                                                                           placeholder="SP Default Relay State" disabled={true}
                                                                           value={this.props.settings.spMetadata ? this.props.settings.spMetadata.defaultRelayState : ''}/>
                                                                    <button className="btn btn-light" onClick={() => this.copyToClipbooard('sp-default-relay-state')}>Copy</button>
                                                                </div>
                                                            </div>
                                                            <div>&nbsp;</div>
                                                            <div className="row form-group">
                                                                <div className="col-sm-12 label bold">
                                                                    <b className="title mt-2 mb-3">Enter values from your SAML Identity Provider below to configure the Xosphere SAML Service Provider.</b>
                                                                </div>
                                                            </div>
                                                            <div className="row form-group">
                                                                <div className="col-sm-5 label text-right">
                                                                    <label>Service Provider (SP) Configuration Mode:</label>
                                                                </div>
                                                                <div className="col-sm-7">
                                                                    <div className="custom-control custom-radio d-block">
                                                                        <input type="radio" id="sp-config-mode-metadata-url" name="spConfigModes"
                                                                               disabled={this.isReadOnly()}
                                                                               checked={this.state.spConfigMode === MetadataUrl ? true : false}
                                                                               value={MetadataUrl}
                                                                               className="custom-control-input"
                                                                               onChange={this.handleSpConfigMode} />
                                                                        <label className="custom-control-label" htmlFor="sp-config-mode-metadata-url">Metadata URL</label>
                                                                    </div>
                                                                    <div className="custom-control custom-radio d-block">
                                                                        <input type="radio" id="sp-config-mode-metadata-file" name="spConfigModes"
                                                                               disabled={this.isReadOnly()}
                                                                               checked={this.state.spConfigMode === MetadataFile ? true : false}
                                                                               value={MetadataFile}
                                                                               className="custom-control-input"
                                                                               onChange={this.handleSpConfigMode} />
                                                                        <label className="custom-control-label" htmlFor="sp-config-mode-metadata-file">Metadata File</label>
                                                                    </div>
                                                                    <div className="custom-control custom-radio d-block">
                                                                        <input type="radio" id="sp-config-mode-specify-field-values" name="spConfigModes"
                                                                               disabled={this.isReadOnly()}
                                                                               checked={this.state.spConfigMode === SpecifyFieldValues ? true : false}
                                                                               value={SpecifyFieldValues}
                                                                               className="custom-control-input"
                                                                               onChange={this.handleSpConfigMode} />
                                                                        <label className="custom-control-label" htmlFor="sp-config-mode-specify-field-values">Specify Field Values</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {
                                                                this.state.spConfigMode === MetadataUrl ? (
                                                                <div id="idp-config-metadata-url">
                                                                    <div className="row form-group">
                                                                        <div className="col-sm-5 label text-right">
                                                                            <label>IdP Metadata URL:</label>
                                                                        </div>
                                                                        <div className="col-sm-7">
                                                                            <input type="text" className="form-control"
                                                                                   placeholder="IdP Metadata URL"
                                                                                   disabled={this.isReadOnly()}
                                                                                   onChange={e => this.handleInputChange(e, "idpMetadataUrl")}
                                                                                   value={this.state.idpMetadataUrl || ''}/>
                                                                        </div>
                                                                    </div>
                                                                </div>) :null
                                                            }
                                                            {
                                                                this.state.spConfigMode === MetadataFile ? (
                                                                <div id="idp-config-metadata-file">
                                                                    <div className="row form-group">
                                                                        <div className="col-sm-5 label text-right">
                                                                            <label>IdP Metadata XML File:</label>
                                                                        </div>
                                                                        <div className="col-sm-7">
                                                                            <input type="file" className="form-control"
                                                                                   placeholder="IdP Metadata XML File"
                                                                                   disabled={this.isReadOnly()}
                                                                                   onChange={e => this.handleFileChange(e, "idpMetadataXmlFile", "idpMetadataXml")}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>) :null
                                                            }
                                                            {
                                                                this.state.spConfigMode === SpecifyFieldValues ? (
                                                                <div id="idp-config-specify-field-values">
                                                                    <div className="row form-group">
                                                                        <div className="col-sm-5 label text-right">
                                                                            <label>IdP SSO URL:</label>
                                                                        </div>
                                                                        <div className="col-sm-7">
                                                                            <input type="text" className="form-control"
                                                                                   placeholder="SSO URL"
                                                                                   disabled={this.isReadOnly()}
                                                                                   onChange={e => this.handleInputChange(e, "idpSsoUrl")}
                                                                                   value={this.state.idpSsoUrl || ''}/>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row form-group">
                                                                        <div className="col-sm-5 label text-right">
                                                                            <label>IdP Issuer:</label>
                                                                        </div>
                                                                        <div className="col-sm-7">
                                                                            <input type="text" className="form-control"
                                                                                   placeholder="IdP Issuer"
                                                                                   disabled={this.isReadOnly()}
                                                                                   onChange={e => this.handleInputChange(e, "idpIssuer")}
                                                                                   value={this.state.idpIssuer || ''}/>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row form-group">
                                                                        <div className="col-sm-5 label text-right">
                                                                            <label>IdP Certificate File (.PEM
                                                                                format):</label>
                                                                        </div>
                                                                        <div className="col-sm-7">
                                                                            <label>{this.state.certExpiration !== null ? '(Expires: ' + this.formatDate(this.state.certExpiration) + ')' : ''}</label>
                                                                            <input type="file" className="form-control"
                                                                                   placeholder="IdP Certificate File"
                                                                                   disabled={this.isReadOnly()}
                                                                                   onChange={e => this.handleFileChange(e, "idpCertificateFile", "idpCertificateData")}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>) : null
                                                            }
                                                            <div className="row form-group">
                                                                <div className="col-sm-5 label text-right">
                                                                    <label>Email Address Attribute:</label>
                                                                </div>
                                                                <div className="col-sm-7 label">
                                                                    <label>(Leave blank if the Name ID is the user's email address)</label>
                                                                    <input type="text" className="form-control"
                                                                              placeholder="Email Address Attribute Name"
                                                                              disabled={this.isReadOnly()}
                                                                              onChange={e => this.handleInputChange(e, "emailAddrAttribute")}
                                                                              value={this.state.emailAddrAttribute || ''}/>
                                                                </div>
                                                            </div>
                                                            <div className="row form-group">
                                                                <div className="col-sm-5 label text-right">
                                                                    <label>Default User Type:</label>
                                                                </div>
                                                                <div className="col-lg-7 col-md-6 d-flex align-items-center">
                                                                    <select id="defaultUserTypeSelect"
                                                                        defaultValue={this.state.defaultUserType}
                                                                        disabled={this.isReadOnly()}
                                                                        onChange={e => this.handleDefaultUserTypeChange(e)}
                                                                        ref="defaultUserTypeSelect">
                                                                            <option value={User}>User</option>
                                                                            <option value={ReadOnlyUser}>Read-only User</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                    </div>
                                                </div>
                                                {
                                                    this.state.spKeyAndCertCreated && this.state.ssoEnabled &&
                                                    <div className="row">
                                                        <div className="col-md-12 text-right">
                                                            <button type="submit" className="btn btn-light"
                                                                    disabled={this.isReadOnly()}
                                                                    onClick={e => this.handleSsoCancel(e)}>Cancel
                                                            </button>
                                                            <button type="submit" className="btn btn-primary ml-2"
                                                                    disabled={this.isReadOnly()}
                                                                    onClick={e => this.handleSsoSave(e)}>Save
                                                            </button>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal isOpen={this.state.addUser} onHide={e => {
                    this.setState({addUser: false})
                }} toggle={this.toggleAddUser} size="lg">
                    <ModalHeader toggle={this.toggleAddUser}><strong>Add User</strong></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-lg-6 col-md-9 col-sm-9">
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="60"><label className="mt-2">Name:</label></td>
                                                <td><input type="text" className="form-control"
                                                           onChange={e => this.handleEditUserName(e)}/></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="60"><label className="mt-2">Email:</label></td>
                                                <td><input type="text" className="form-control"
                                                           onChange={e => this.handleEditUserEmail(e)}/></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group form-row">
                                        <div className="col-auto"><input type="checkbox" className="form-check-input"
                                                                         id="Checkmeout"
                                                                         checked={this.state.editedUser ? this.state.editedUser.weeklyEmail : true}
                                                                         onChange={e => this.handleEditUserWeeklyEmail(e)}/>
                                        </div>
                                        <div className="col"><label className="form-check-label" htmlFor="Checkmeout">Receive
                                            weekly savings digest email</label></div>
                                    </div>
                                    <div className="form-group form-row">
                                        <div className="col-auto"><input type="checkbox" className="form-check-input"
                                                                         id="Checkmeout2"
                                                                         checked={this.state.editedUser ? this.state.editedUser.readOnly : false}
                                                                         onChange={e => this.handleEditUserReadOnly(e)}/>
                                        </div>
                                        <div className="col"><label className="form-check-label" htmlFor="Checkmeout2">ReadOnly</label></div>
                                    </div>
                                    <div className="form-group form-row">
                                        <div className="col-auto"><input type="checkbox" className="form-check-input"
                                                                         id="Checkmeout3"
                                                                         checked={this.state.editedUser ? this.state.editedUser.ssoLoginOnly : false}
                                                                         onChange={e => this.handleEditUserSsoLoginOnly(e)}/>
                                        </div>
                                        <div className="col"><label className="form-check-label" htmlFor="Checkmeout3">SSO Login Only</label></div>
                                    </div>
                                    <div className="form-group text-right mt-4">
                                        <button type="button" className="btn btn-sm btn-primary"
                                                onClick={e => this.handleAddUserSubmit(e)}>Add User
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.editUser} onHide={e => {
                    this.setState({editUser: false})
                }} toggle={this.toggleEditUser} size="lg">
                    <ModalHeader toggle={this.toggleEditUser}><strong>Edit User</strong></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-lg-6 col-md-9 col-sm-9">
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="60"><label className="mt-2">Name:</label></td>
                                                <td><input type="text" className="form-control"
                                                           value={this.state.editedUser ? this.state.editedUser.name : ""}
                                                           onChange={e => this.handleEditUserName(e)}/></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="60"><label className="mt-2">Email:</label></td>
                                                <td><input type="text" className="form-control"
                                                           value={this.state.editedUser ? this.state.editedUser.email : ""}
                                                           onChange={e => this.handleEditUserEmail(e)}/></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group form-row">
                                        <div className="col-auto"><input type="checkbox" className="form-check-input"
                                                                         id="Checkmeout"
                                                                         checked={this.state.editedUser && this.state.editedUser.weeklyEmail}
                                                                         onChange={e => this.handleEditUserWeeklyEmail(e)}/>
                                        </div>
                                        <div className="col"><label className="form-check-label" htmlFor="Checkmeout">Receive
                                            weekly savings digest email</label></div>
                                    </div>
                                    <div className="form-group form-row">
                                        <div className="col-auto"><input type="checkbox" className="form-check-input"
                                                                         id="Checkmeout2"
                                                                         checked={this.state.editedUser && this.state.editedUser.readOnly}
                                                                         onChange={e => this.handleEditUserReadOnly(e)}/>
                                        </div>
                                        <div className="col"><label className="form-check-label" htmlFor="Checkmeout2">ReadOnly</label></div>
                                    </div>
                                    <div className="form-group text-right mt-4">
                                        <button type="button" className="btn btn-sm btn-primary"
                                                onClick={e => this.handleEditUserSubmit(e)}>Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.changePassword} onHide={e => {
                    this.setState({changePassword: false, cpError: null})
                }} toggle={this.toggleChangePassword} size="lg">
                    <ModalHeader toggle={this.toggleChangePassword}><strong>Change Password</strong></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <Error errorMsg={this.state.cpError} divClass="col-lg-5 col-sm-6 col-center"/>
                                <div className="col-lg-6 col-md-9 col-sm-9">
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="90"><div className="form-group row mb-4"><label className="mt-2">Current Password:</label></div></td>
                                                <td><div className="form-group row mb-4"><div className="col-10"><input type={this.state.showOldPassword === true ? "text" : "password"} className="form-control" autocomplete="current-password" maxLength="128"
                                                                     onChange={e => this.handleEditOldPassword(e)}/></div><div className="col-1"><div className="mt-2"><a href="#" className="gray" onClick={this.toggleOldPassword}><i className="fa fa-eye"></i></a>
                                                </div></div></div></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="90"><div className="form-group row mb-4"><label className="mt-2">Password:</label></div></td>
                                                <td><div className="form-group row mb-4"><div className="col-10"><input type={this.state.showPassword === true ? "text" : "password"} className="form-control" autocomplete="new-password" maxLength="64"
                                                                                   onChange={e => this.handleEditPassword(e)}/><PasswordStrengthBar password={this.state.password} /></div><div className="col-1"><div className="mt-2"><a href="#" className="gray" onClick={this.togglePassword}><i className="fa fa-eye"></i></a>
                                                </div></div></div></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group text-right mt-4">
                                        <button type="button" className="btn btn-sm btn-primary"
                                                onClick={e => this.handleChangePasswordSubmit(e)}>Change Password
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.addAccount} onHide={e => {
                    this.setState({addAccount: false})
                }} toggle={this.toggleAddAccount} size="lg">
                    <ModalHeader toggle={this.toggleAddAccount}><strong>Add Authorization</strong></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-lg-6 col-md-9 col-sm-9">
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="160"><label className="mt-2">Cloud Provider:</label></td>
                                                <td>
                                                    <select className="form-control" value={this.state.cloudprovider} onChange={this.handleCloudprovider} disabled={this.isReadOnly()}>
                                                        <option value="aws">AWS</option>
                                                        <option value="gcp">GCP</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    {
                                        this.state.cloudprovider === 'aws' ?
                                            (<div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="160"><label className="mt-2">Partition:</label></td>
                                                <td>
                                                    <select className="form-control" disabled={true} onChange={this.handleAddPartition}>
                                                        <option value="aws">Commercial</option>
                                                        <option value="aws-us-gov">GovCloud</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>) : null
                                    }
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="160"><label className="mt-2">Entity Type:</label></td>
                                                <td>
                                                    {this.state.cloudprovider === 'aws' ?
                                                        (<select className="form-control" onChange={this.handleChangeAccountOrOrg}>
                                                        <option value="account">Account</option>
                                                        <option value="organization">Organization</option>
                                                    </select>) : (
                                                            <select className="form-control">
                                                                <option value="project">Project</option>
                                                            </select>
                                                        )
                                                    }
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="160"><label className="mt-2">ID:</label></td>
                                                <td><input type="text" className="form-control"
                                                           onChange={e => this.handleAddAccountId(e)}/></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="160"><label className="mt-2">Name:</label></td>
                                                <td><input type="text" className="form-control"
                                                           onChange={e => this.handleAddAccountName(e)}/></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    {
                                        this.state.cloudprovider === "aws" ? (
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="160"><label className="mt-2">Enterprise Discount:</label>
                                                </td>
                                                <td>
                                                    <table>
                                                        <tr>
                                                            <td><input type="text" className="form-control"
                                                                       style={{textAlign: "right"}}
                                                                       onChange={e => this.handleAddAccountEnterpriseDiscount(e)}/>
                                                            </td>
                                                            <td>%</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                        ) : null
                                    }
                                    <div className="form-group text-right mt-4">
                                        <button type="button" className="btn btn-sm btn-primary"
                                                onClick={e => this.handleAddAccountSubmit(e)}>Add Authorization
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                {/*<Modal isOpen={this.state.addProject} onHide={e => {*/}
                {/*    this.setState({addProject: false})*/}
                {/*}} toggle={this.toggleAddProject} size="lg">*/}
                {/*    <ModalHeader toggle={this.toggleAddProject}><strong>Add GCP Project</strong></ModalHeader>*/}
                {/*    <ModalBody>*/}
                {/*        <div className="modal-body">*/}
                {/*            <div className="row justify-content-center">*/}
                {/*                <div className="col-lg-6 col-md-9 col-sm-9">*/}
                {/*                    <div className="form-group">*/}
                {/*                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">*/}
                {/*                            <tbody>*/}
                {/*                            <tr>*/}
                {/*                                <td width="160"><label className="mt-2">Cloud Provider:</label></td>*/}
                {/*                                <td><input type="text" value="GCP" disabled className="form-control"/>*/}
                {/*                                </td>*/}
                {/*                            </tr>*/}
                {/*                            </tbody>*/}
                {/*                        </table>*/}
                {/*                    </div>*/}
                {/*                    <div className="form-group">*/}
                {/*                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">*/}
                {/*                            <tbody>*/}
                {/*                            <tr>*/}
                {/*                                <td width="160"><label className="mt-2">Entity Type:</label></td>*/}
                {/*                                <td>*/}
                {/*                                    <select className="form-control">*/}
                {/*                                        <option value="project">Project</option>*/}
                {/*                                    </select>*/}
                {/*                                </td>*/}
                {/*                            </tr>*/}
                {/*                            </tbody>*/}
                {/*                        </table>*/}
                {/*                    </div>*/}
                {/*                    <div className="form-group">*/}
                {/*                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">*/}
                {/*                            <tbody>*/}
                {/*                            <tr>*/}
                {/*                                <td width="160"><label className="mt-2">ID:</label></td>*/}
                {/*                                <td><input type="text" className="form-control"*/}
                {/*                                           onChange={e => this.handleAddProjectId(e)}/></td>*/}
                {/*                            </tr>*/}
                {/*                            </tbody>*/}
                {/*                        </table>*/}
                {/*                    </div>*/}
                {/*                    <div className="form-group">*/}
                {/*                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">*/}
                {/*                            <tbody>*/}
                {/*                            <tr>*/}
                {/*                                <td width="160"><label className="mt-2">Name:</label></td>*/}
                {/*                                <td><input type="text" className="form-control"*/}
                {/*                                           onChange={e => this.handleAddProjectName(e)}/></td>*/}
                {/*                            </tr>*/}
                {/*                            </tbody>*/}
                {/*                        </table>*/}
                {/*                    </div>*/}

                {/*                    <div className="form-group text-right mt-4">*/}
                {/*                        <button type="button" className="btn btn-sm btn-primary"*/}
                {/*                                onClick={e => this.handleAddProjectSubmit(e)}>Add Project*/}
                {/*                        </button>*/}
                {/*                    </div>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </ModalBody>*/}
                {/*</Modal>*/}

                <Modal isOpen={this.state.editAccount} onHide={e => {
                    this.setState({editAccount: false})
                }} toggle={this.toggleEditAccount} size="lg">
                    <ModalHeader toggle={this.toggleEditAccount}><strong>Edit Account/Organization</strong></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-lg-6 col-md-9 col-sm-9">
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="180"><label className="mt-2">Cloud Provider:</label></td>
                                                <td><input type="text" className="form-control" value="AWS" disabled/>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="180"><label className="mt-2">Partition:</label></td>
                                                <td><select className="form-control" disabled={true}
                                                        value={(this.state.editedAccount && this.state.accountOrOrg === "account") ? this.state.editedAccount.aws_partition : (
                                                            (this.state.editedOrg && this.state.accountOrOrg === "organization") ? this.state.editedOrg.aws_partition :"aws"
                                                        )}
                                                        onChange={e => this.handleEditPartition(e)}>
                                                        <option value="aws">Commercial</option>
                                                        <option value="aws-us-gov">GovCloud</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="180"><label className="mt-2">Entity Type:</label></td>
                                                <td><select className="form-control" disabled={true}
                                                           value={this.state.accountOrOrg ? this.state.accountOrOrg : "account"}>
                                                    <option value="account">Account</option>
                                                    <option value="organization">Organization</option>
                                                </select>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="180"><label className="mt-2">{(this.state.editedAccount && this.state.accountOrOrg === "account") ? "Account ID" : "Organization ID"}</label></td>
                                                <td><input type="text" className="form-control" disabled={true}
                                                           value={(this.state.editedAccount && this.state.accountOrOrg === "account") ? this.state.editedAccount.id : (
                                                               (this.state.editedOrg && this.state.accountOrOrg === "organization") ? this.state.editedOrg.id :""
                                                           )}
                                                           onChange={e => this.handleEditAccountId(e)}/>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="180"><label className="mt-2">Name:</label></td>
                                                <td><input type="text" className="form-control"
                                                           value={(this.state.editedAccount && this.state.accountOrOrg === "account") ? this.state.editedAccount.name :
                                                               (
                                                               (this.state.editedOrg && this.state.accountOrOrg === "organization") ? this.state.editedOrg.name: "")
                                                               }
                                                           onChange={e => this.handleEditAccountName(e)}/>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="180"><label className="mt-2">Enterprise Discount:</label>
                                                </td>
                                                <td>
                                                    <table>
                                                        <tr>
                                                            <td>
                                                                <input type="text" className="form-control"
                                                                       style={{textAlign: "right"}}
                                                                       value={(this.state.editedAccount && this.state.accountOrOrg === "account") ? this.formatPercent(this.state.editedAccount.discount) :
                                                                           (
                                                                               (this.state.editedOrg && this.state.accountOrOrg === "organization") ? this.formatPercent(this.state.editedOrg.discount) : ""
                                                                           )}
                                                                       onChange={e => this.handleEditEnterpriseDiscount(e)}/>
                                                            </td>
                                                            <td>%</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group text-right mt-4">
                                        <button type="button" className="btn btn-sm btn-primary"
                                                onClick={e => this.handleEditAccountSubmit(e)}>Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.editProject} onHide={e => {
                    this.setState({editProject: false})
                }} toggle={this.toggleEditProject} size="lg">
                    <ModalHeader toggle={this.toggleEditProject}><strong>Edit GCP Project</strong></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-lg-6 col-md-9 col-sm-9">
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="180"><label className="mt-2">Cloud Provider:</label></td>
                                                <td><input type="text" className="form-control" value="GCP" disabled/>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="180"><label className="mt-2">Entity Type:</label></td>
                                                <td><select className="form-control" disabled={true}>
                                                    <option value="project">Project</option>
                                                </select>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="180"><label className="mt-2">Project ID:</label></td>
                                                <td><input type="text" className="form-control" disabled={true}
                                                           value={this.state.editedProject ? this.state.editedProject.id : ""}
                                                           onChange={e => this.handleEditProjectId(e)}/>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="180"><label className="mt-2">Name:</label></td>
                                                <td><input type="text" className="form-control"
                                                           value={this.state.editedProject ? this.state.editedProject.name: ''}
                                                           onChange={e => this.handleEditProjectName(e)}/>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="form-group text-right mt-4">
                                        <button type="button" className="btn btn-sm btn-primary"
                                                onClick={e => this.handleEditProjectSubmit(e)}>Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.addScoping} onHide={e => {
                    this.setState({addScoping: false})
                }} toggle={this.toggleAddScoping} size="lg">
                    <ModalHeader toggle={this.toggleAddScoping}><strong>Add Scope</strong></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-lg-6 col-md-9 col-sm-9">
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="160"><label className="mt-2">Tag Key:</label></td>
                                                <td><input type="text"  className="form-control" onChange={e => this.handleEditScopingTagKey(e)}/>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="160"><label className="mt-2">Display Name:</label></td>
                                                <td><input type="text" className="form-control"
                                                           onChange={e => this.handleEditScopingDisplayName(e)}/></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group text-right mt-4">
                                        <button type="button" className="btn btn-sm btn-primary"
                                                onClick={e => this.handleAddScopingSubmit(e)}>Add Scope
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.editScoping} onHide={e=> {this.setState({editScoping: false})}} toggle={this.toggleEditScoping} size="lg">
                    <ModalHeader toggle={this.toggleEditScoping}><strong>Edit Scope</strong></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-lg-6 col-md-9 col-sm-9">
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="160"><label className="mt-2">Tag Key:</label></td>
                                                <td><input type="text"  value={this.state.editedScoping? this.state.editedScoping.tagKey: ""} className="form-control" onChange={e => this.handleEditScopingTagKey(e)}/>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group">
                                        <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                                            <tbody>
                                            <tr>
                                                <td width="160"><label className="mt-2">Display Name:</label></td>
                                                <td><input type="text" value={this.state.editedScoping? this.state.editedScoping.displayName: ""} className="form-control"
                                                           onChange={e => this.handleEditScopingDisplayName(e)}/></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group text-right mt-4">
                                        <button type="button" className="btn btn-sm btn-primary"
                                                onClick={e => this.handleEditScopingSubmit(e)}>Update Scope
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.showDelete} toggle={this.toggleShowDelete} size="lg">
                    <ModalBody>
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-lg-12 text-center">
                                    <i className="fa fa-warning fa-3x text-warning mt-4"></i>
                                    <h5 className="mt-4 mb-4">Are you sure you want to delete this item?</h5>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-light" data-dismiss="modal"
                                aria-label="Close" onClick={this.handleCancelDelete}>Cancel
                        </button>
                        <input type="submit" value="Delete" className="btn btn-primary"
                               onClick={e => this.handleDelete(e)}/>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.showRevoke} toggle={this.toggleShowRevoke} size="lg">
                    <ModalBody>
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-lg-12 text-center">
                                    <i className="fa fa-warning fa-3x text-warning mt-4"></i>
                                    <h5 className="mt-4 mb-4">Are you sure you want to revoke this session?</h5>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-light" data-dismiss="modal"
                                aria-label="Close" onClick={this.handleCancelRevoke}>Cancel
                        </button>
                        <input type="submit" value="Revoke" className="btn btn-primary"
                               onClick={e => this.handleRevoke(e)}/>
                    </ModalFooter>
                </Modal>
            </div>
        )

    }
}

const mapStateToProps = state => {
    return {
        token: state.settings.token || state.login.token,
        loading: state.settings.loading,
        error: state.settings.error,
        settings: state.settings.settings,
        company: state.login.company,
        permissions: state.login.permissions,
        hasGcp: state.login.hasGcp,
        gcpOnly: state.login.gcpOnly,
        cpError: state.settings.cpError,
        fromPost: state.settings.fromPost,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchSettings: (token) => dispatch(actions.fetchAccountSettings(token)),
        onSaveCompanyInfo: (token, companyInfo) => dispatch(actions.saveCompanyInfo(token, companyInfo)),
        onUpdateAccount: (token, accounts, orgs, gcpProjects) => dispatch(actions.editCloudAccount(token, accounts, orgs, gcpProjects)),
        onUpdateUser: (token, user) => dispatch(actions.editUser(token, user)),
        onAddUser: (token, user) => dispatch(actions.addUser(token, user)),
        onDeleteUser: (token, user) => dispatch(actions.deleteUser(token, user)),
        onDeleteApiKey: (token, key) => dispatch(actions.deleteApiKey(token, key)),
        onGenerateApiKey: (token) => dispatch(actions.generateApiKey(token)),
        onChangePassword: (token, oldPassword, password) => dispatch(actions.changePassword(token, oldPassword, password)),
        onRevokeSession: (token, sessionToken) => dispatch(actions.deleteSession(token, sessionToken)),
        onUpdateScopings: (token, scopings) => dispatch(actions.editScopings(token, scopings)),
        onSaveSsoConfig: (token, ssoConfig) => dispatch(actions.saveSsoConfig(token, ssoConfig)),
        onLogout: (token) => dispatch(actions.logout(token))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountSettings);